/**
 * Tournament Label Utilities
 * Provides dynamic labels based on sport_type and sport_format
 */

export const getTournamentLabels = (sportType, sportFormat) => {
    const isIndividual = sportFormat === 'individual';
    const isEsports = sportType === 'esports';
    const isRacket = sportType === 'sets';

    // Determine entity type
    let entity, entityPlural, logo;

    if (isRacket) {
        entity = 'Deelnemer';
        entityPlural = 'Deelnemers';
        logo = 'Foto';
    } else if (isEsports && isIndividual) {
        entity = 'Speler';
        entityPlural = 'Spelers';
        logo = 'Avatar';
    } else {
        entity = 'Team';
        entityPlural = 'Teams';
        logo = 'Logo';
    }

    return {
        // Capitalized
        entity,
        entityPlural,
        logo,

        // Lowercase
        entityLower: entity.toLowerCase(),
        entityPluralLower: entityPlural.toLowerCase(),
        logoLower: logo.toLowerCase(),

        // Common phrases
        addNew: `Nieuwe ${entity}`,
        noEntities: `Nog geen ${entityPlural.toLowerCase()}`,
        manage: `Beheer ${entityPlural.toLowerCase()} voor dit toernooi`,
        entityName: `${entity} Naam`,
        entityLogo: `${entity} ${logo}`,

        // For forms
        namePlaceholder: `Naam van ${entity.toLowerCase()}`,
        logoPlaceholder: `${logo} URL`,

        // For AI generator
        aiGeneratorTitle: `✨ AI ${logo} Generator`,
        aiGeneratorButton: `🎨 Genereer AI ${logo}'s`,

        // For tips/help
        importTip: `Importeer je ${entityPlural.toLowerCase()} direct vanuit Excel/CSV via de "Import" knop hierboven.`,
        aiTip: `Geen inspiratie? Klik op "AI Inspiratie" voor hilarische ${entityPlural.toLowerCase()}namen.`,
        selfRegisterTip: `Wil je ${entityPlural.toLowerCase()} zelf laten inschrijven? Stuur ze de "Inschrijfformulier" link (rechtsboven).`
    };
};

// Export for backwards compatibility with existing code
export const getEntityLabel = (sportType, sportFormat) => {
    const labels = getTournamentLabels(sportType, sportFormat);
    return labels.entity;
};

export const getEntityLabelPlural = (sportType, sportFormat) => {
    const labels = getTournamentLabels(sportType, sportFormat);
    return labels.entityPlural;
};
